/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import SignInForm from "../../Component/Auth/SignInForm";
import { useNavigate } from "react-router-dom";

export default function SignIn() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/userprofile");
    }
  }, []);
  return <SignInForm />;
}
